'use client'

import { Button } from '@/components/ui/button'
import { KeyboardShortcutsDialog } from '../KeyboardShortcutsDialog'

export function NavigationSection() {
  return (
    <section aria-labelledby="a11y-nav-heading" className="flex flex-col gap-4">
      <h3 id="a11y-nav-heading" className="text-base font-semibold">
        Navigacija
      </h3>

      <p className="text-muted-foreground text-sm">
        Platformu možeš koristiti samo tastaturom. Pritisni dugme ispod za listu svih prečica.
      </p>

      <KeyboardShortcutsDialog
        trigger={
          <Button variant="outline" size="sm" className="w-fit">
            Prikaži tastaturne prečice
          </Button>
        }
      />
    </section>
  )
}
